module.exports = __webpack_public_path__ + "img/statistics_icon1.08f8178c.png";